import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import DashboardSidebar from "./DashboardSidebar";
import { addIcon, cardLinkIcon, editIcon } from "../assets";
import "../styles/dashboard.styles.css";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";

function CardEdit() {
  const { toolId } = useParams();

  const [newTool, setNewTool] = useState({
    backgroundImageUrl: "",
    toolTag: "",
    toolType: "",
    toolTitle: "",
    toolLink: "",
    toolDescription: "",
  });

  useEffect(() => {
    if (toolId) {
      axios
        .get(`https://devuse-fullstack.vercel.app/tools/details/${toolId}`)
        .then((response) => {
          const data = response.data;
          if (data && data.backgroundImageUrl) {
            setNewTool({
              backgroundImageUrl: data.backgroundImageUrl,
              toolTag: data.toolTag,
              toolType: data.toolType,
              toolTitle: data.toolTitle,
              toolLink: data.toolLink,
              toolDescription: data.toolDescription,
            });
          } else {
            console.error("Invalid data received from the server:", data);
          }
        })
        .catch((error) => {
          console.error("Error fetching tool details:", error);
        });
    }
  }, [toolId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewTool({
      ...newTool,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(
        `https://devuse-fullstack.vercel.app/tools/update-tool/${toolId}`,
        newTool
      );
      toast.success("Tool updated successfully");
    } catch (error) {
      toast.error("An unexpected error occurred.");
    }
  };

  return (
    <div>
      <ToastContainer />
      <Grid container justifyContent={"center"}>
        <Grid item lg={11.5}>
          <Grid lg={1}>
            <DashboardSidebar />
          </Grid>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"80vh"}
          >
            <Grid item lg={4.5}>
              <Grid container>
                <Grid xs={10} sm={4.9} md={4.2} lg={8}>
                  <div className="card">
                    <div className="card_img_container">
                      <img src={newTool.backgroundImageUrl} alt="tools" />
                    </div>
                    <div className="card_content_container">
                    <div className="tag">
                        <div className="tag_width">
                          <span>{newTool.toolTag}</span>
                        </div>
                        {newTool.toolType && (
                          <div className="tool-version-dashboard">{newTool.toolType}</div>
                        )}
                      </div>
                      <a
                        href={newTool.toolLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="card_link_container">
                          <h1>{newTool.toolTitle}</h1>
                          <img
                            src={cardLinkIcon}
                            className="link_image"
                            alt="link-icon"
                          />
                        </div>
                      </a>
                      <p>{newTool.toolDescription}</p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={4}>
              <div className="l-input-container">
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="Update tool img URL"
                    name="backgroundImageUrl"
                    value={newTool.backgroundImageUrl}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    name="toolTag"
                    value={newTool.toolTag}
                    onChange={handleChange}
                    placeholder="Update tool tag"
                  />
                  <input
                    type="text"
                    name="toolType"
                    value={newTool.toolType}
                    onChange={handleChange}
                    placeholder="Update tool type"
                  />
                  <input
                    type="text"
                    name="toolTitle"
                    value={newTool.toolTitle}
                    onChange={handleChange}
                    placeholder="Update tool title"
                  />
                  <input
                    type="text"
                    name="toolLink"
                    value={newTool.toolLink}
                    onChange={handleChange}
                    placeholder="Update tool link"
                  />
                  <input
                    type="text"
                    name="toolDescription"
                    value={newTool.toolDescription}
                    onChange={handleChange}
                    placeholder="Update tool description"
                  />
                  <button type="submit">
                    <img src={editIcon} alt="edit form icon" />
                  </button>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default CardEdit;
